import {ValueObject} from '@s-ui/domain'

export class EquipmentSectionValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {String} params.title
   * @param {Array} params.descriptions
   * */
}
